module.exports = __webpack_public_path__ + "img/四川天府新区华阳实验幼儿园.6033c606.jpg";